import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deSelectAllContract,
  fetchUnfilledContracts,
  setUnfilledContractsLoading,
  updateFilters,
  updatePagination,
  showFilterModal,
} from "@/reducers/clientunfilledcontracts";
import { getIsFilterApplied } from "@/utilities/utils";

import TableSearch from "../../dataTables/TableSearch";
import FilterButton from "../../ListingFilters/FilterButton";

const SearchFilter = () => {
  const { filters, pagination } = useSelector(
    (state) => state.clientUnfilledContracts,
  );
  const filterApplied = getIsFilterApplied(filters);
  const dispatch = useDispatch();
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setUnfilledContractsLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectAllContract());
      dispatch(fetchUnfilledContracts(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);
  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};

export default SearchFilter;
